export default __webpack_public_path__ + "static/media/ARR Mascots-09.8d2f8bcb.jpg";